import React, { useEffect, useState } from "react"
import classnames from "classnames"

import * as styles from "./Section.module.css"

const Section = ({ children, id }: { children: any; id: string }) => {
  const [headerId, setHeaderId] = useState("")

  useEffect(() => {
    if (children.props?.children.length > 0)
      children.props.children.find((x: { props: { children: any[] } }) => {
        const found =
          x.props.children &&
          x.props.children.length > 0 &&
          x.props.children.find((y: { props: { mdxType: string } }) => {
            if (y.props?.mdxType)
              return (
                y.props.mdxType === "h1" ||
                y.props.mdxType === "Primary" ||
                y.props.mdxType === "Secondary"
              )
          })

        if (found && found.props.mdxType === "h1") {
          found && setHeaderId(found.props.id)
        } else if (found && found.props?.children?.props) {
          setHeaderId(found.props.children.props.id)
        }

        return found
      })
    else {
      if (children.length > 0)
        children.find(
          (x: {
            props: {
              mdxType: string
              id: React.SetStateAction<string>
              children: { props: { id: React.SetStateAction<string> } }
            }
          }) => {
            if (x.props?.mdxType === "h1") {
              setHeaderId(x.props.id)
            } else if (x.props?.children?.props) {
              setHeaderId(x.props.children.props.id)
            }
          }
        )
    }
  }, [])

  return (
    <section
      id={id ?? headerId ?? children[0]?.props.id}
      className={classnames("section", styles.section)}
    >
      {children}
    </section>
  )
}

export default Section

export const SimpleSection = ({
  children,
  bgColor,
  hasCut,
  contentCenter,
  style,
}: {
  children: React.ReactNode
  bgColor?: string
  hasCut?: boolean
  style: React.CSSProperties
  contentCenter: boolean
}) => (
  <section
    style={{
      backgroundColor: bgColor,
      clipPath: hasCut
        ? "polygon(30px 0%, 100% 0px, 100% 50%, 100% 100%, 0px 99%, 0px 50px)"
        : undefined,
      margin: 0,
      textAlign: contentCenter ? "center" : "initial",
      ...style,
    }}
  >
    {children}
  </section>
)
